import { render, staticRenderFns } from "./chantier-inspection.vue?vue&type=template&id=8807e2a0"
import script from "./chantier-inspection.vue?vue&type=script&lang=ts"
export * from "./chantier-inspection.vue?vue&type=script&lang=ts"
import style0 from "./chantier-inspection.vue?vue&type=style&index=0&id=8807e2a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports